import { createFeatureSelector, createSelector } from "@ngrx/store";
import { unreadNotificationFeatureKey, UnreadNotificationState } from "../reducers/unread-notification.reducer";

export const selectUnreadNotificationState = createFeatureSelector<UnreadNotificationState>(unreadNotificationFeatureKey);

export const selectUnreadNotifications = createSelector(
  selectUnreadNotificationState,
  (state: UnreadNotificationState) => state.unreadNotification
);
